export enum Status {
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED',
  FAILED = 'FAILED',
  VOIDED = 'VOIDED',
  COMPLETED = 'COMPLETED',
}
